import type { VideoItem } from "@/mocks/videos";

interface PlayerDemoProps {
  video: VideoItem;
  playing: boolean;
  onToggle: () => void;
}

export default function PlayerDemo({ video, playing, onToggle }: PlayerDemoProps) {
  return (
    <div className="w-full">
      <div className="relative w-full aspect-video overflow-hidden rounded-lg bg-foreground-950">
        <img
          src={video.cover}
          alt={`${video.title} 播放画面`}
          title={`${video.title} 在线播放`}
          className={`h-full w-full object-cover object-top transition-all duration-500 ${
            playing ? "opacity-60 scale-105" : "opacity-90"
          }`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-foreground-950/30" />

        <button
          type="button"
          onClick={onToggle}
          aria-label={playing ? "暂停演示" : "播放演示"}
          className="group absolute inset-0 flex items-center justify-center"
        >
          <span className="flex h-16 w-16 md:h-20 md:w-20 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform group-hover:scale-110">
            <i className={playing ? "ri-pause-fill text-3xl md:text-4xl" : "ri-play-fill text-3xl md:text-4xl"} />
          </span>
        </button>

        <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
          <div className="flex items-center gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur">
              <i className={playing ? "ri-pause-line" : "ri-play-line"} />
            </span>
            <div className="h-1 flex-1 overflow-hidden rounded-full bg-background-50/25">
              <div
                className={`h-full rounded-full bg-primary-500 transition-all duration-[3000ms] ${
                  playing ? "w-2/3" : "w-0"
                }`}
              />
            </div>
            <span className="font-label text-xs text-background-200">
              {playing ? "01:24 / 2:06" : "00:00 / 2:06"}
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur">
              <i className="ri-fullscreen-line" />
            </span>
          </div>
        </div>

        <span className="absolute top-3 left-3 rounded-md bg-foreground-950/70 px-2.5 py-1 text-xs font-label text-background-100 backdrop-blur">
          高清 · 演示播放器
        </span>
      </div>

      <p className="mt-3 flex items-start gap-2 rounded-md bg-accent-50 px-3.5 py-2.5 text-xs md:text-sm leading-relaxed text-accent-800">
        <i className="ri-information-line mt-0.5" />
        当前播放器为前端演示效果，不接入真实视频流资源，点击播放按钮仅作界面反馈。
      </p>
    </div>
  );
}